import { css, cx, keyframes } from '@emotion/css';
import fingerIcon from './assets/finger.png';

export const FingerIcon = () => {
  return <img src={fingerIcon} alt="finger" className={cx('w-[34px] h-[34px]', fingerAnimation)} />;
};

// 上下移动动画
const bounceUpDown = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
`;

const fingerAnimation = css`
  animation: ${bounceUpDown} 1.5s ease-in-out infinite;
`;
